module.exports = __webpack_public_path__ + "static/media/EJS.a1a55378.png";